import IntroSlideLabel from './IntroSlideLabel';

export default IntroSlideLabel;
